import { getToken } from "firebase/messaging";
import { messaging } from "./firebase";
import { Dispatch } from "redux";
import { registerDevice, registerMentorDevice } from "./Services/CommonFunction";

const VAPID_KEY = process.env.REACT_APP_VAP_ID;

export const requestForToken = async (
  currentToken: string | undefined,
  dispatch: Dispatch,
  // When true, register the token against the mentor guard so push lands on
  // the MentorUser model (used by MentorChatMessageNotification).
  isMentor: boolean = false,
) => {
  try {
    if (!currentToken) {
      currentToken = await getToken(messaging, {
        vapidKey: VAPID_KEY,
      });
    }
    if (currentToken) {
      if (isMentor) {
        registerMentorDevice(currentToken);
      } else {
        registerDevice(currentToken, dispatch);
      }
    }
  } catch (err) {}
};
